import type { FaireProductEntity } from "../../entity_types/product";

export const p_2abc3hengk: FaireProductEntity = {
  token: "p_2abc3hengk",
  type: "product",
  name: "Sunglasses pineapple Tea Towel",
  brandName: "RHB HAWAII",
  imageUrl:
    "https://cdn.faire.com/fastly/af0557a23992b520614a6c6f7d8d7b3a8a4528d5f1d33e781786f3d774fbdebb.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/26bd1bd8a2ba7244a1bdf90c49a52b22f19d8e307d7aec153ef7883f49001e50.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
